<template>
  <div class="topup-header">
    <div class="topup-header-login">
      <div class="languages">
        <span class="lang" :class="[locale, {active: $i18n.locale() === locale}]"
              v-for="locale in $i18n.locales()"
              :key="'i81n-' + locale"
              @click="setLang(locale)"
              v-text="getLangToDisplay(locale)">
        </span>
      </div>
    </div>
    <div class="topup-header-main">
      <router-link to="/" v-slot="{ href, navigate }" custom>
        <a class="logo" :href="href" @click="navigate" title="Idź do strony plus.pl" >
          <img src="../assets/images/Plus_small_logo.png" alt="Logo Plus"/>
        </a>
      </router-link>
      <div class="slogan" v-html="$t('component.header.title')"></div>
    </div>
  </div>
</template>

<script>
import HeaderMixin from '@/common/mixins/Layout/Header.mixin'

export default {
  name: 'TopupHeader',
  mixins: [HeaderMixin]
}
</script>

<style src="../assets/scss/header.scss" lang="scss"></style>
